// extracted by mini-css-extract-plugin
export default {"header":"toolbar_header__xkovn","buildVersion":"toolbar_buildVersion__eBvdK"};